const ARIA = {
  helpText: "HelpTextAriaDescribedBy",
  error: "ErrorAriaDescribedBy",
  optional: "OptionalAriaDescribedBy",
};

export { ARIA as A };
